import { combineEpics } from "redux-observable";

import getWatchListEntriesEpic$ from "./getWatchListEntriesEpic";
import getWatchListEntryByIdEpic$ from "./getWatchListEntryByIdEpic";
import createWatchListEntryEpic$ from "./createWatchListEntryEpic";
import updateWatchListEntryEpic$ from "./updateWatchListEntryEpic";
import deleteWatchListEntryEpic$ from "./deleteWatchListEntryEpic";
import getWatchListEntriesCountEpic$ from "./getWatchListEntriesCountEpic";
import getWatchListEntriesByWatchListEpic$ from "./getWatchListEntriesByWatchListEpic";
import getWatchListEntriesByWatchListCountEpic$ from "./getWatchListEntriesByWatchListCountEpic";
import exportWatchListEntriesCsvEpic$ from "./exportWatchListEntriesCsvEpic";
import watchListDeactivationEpic$ from "./watchListDeactivationEpic";
import exportWatchListAllEntriesCsvEpic$ from "./exportWatchListAllEntriesCsvEpic";
import uploadCustomWatchlistEpic$ from "./uploadCustomWatchlistEpic";
import getWatchListMultipleSearchEntriesEpic$ from "./getWatchListMultipleSearchEntriesEpic";

export default combineEpics(
  getWatchListEntriesEpic$,
  getWatchListEntryByIdEpic$,
  createWatchListEntryEpic$,
  updateWatchListEntryEpic$,
  deleteWatchListEntryEpic$,
  getWatchListEntriesCountEpic$,
  getWatchListEntriesByWatchListEpic$,
  getWatchListEntriesByWatchListCountEpic$,
  exportWatchListEntriesCsvEpic$,
  watchListDeactivationEpic$,
  exportWatchListAllEntriesCsvEpic$,
  uploadCustomWatchlistEpic$,
  getWatchListMultipleSearchEntriesEpic$
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/index.js